<template>
  <div class="list" :style="{'padding-left': pl ? '260px;' : '0'}">
    <!-- 标题 -->
    <div class="list-title vertical-line">
      <span>{{list&&list.data[0]&&list.data[0].cat_name || '暂无数据'}}</span>
    </div>
    <!-- 列表 -->
    <ul class="list-wrap "  v-if="list&&list.data" >
      <router-link :to='link+item.article_id' tag='li' class="list-wrap-item " v-for="(item, index) in (list&&list.data)" :key="index">
        <div 
        class="list-wrap-item-img"
        v-if="item.images"
        >
          <el-image
            style="width: 200px;height: 120px;" 
            :src="item.images"
            fit="cover">
          </el-image>
        </div>
        <div class="list-wrap-item-right" :class="{notImage: !item.images}">
          <div class="list-wrap-item-right-title">{{item.title}}</div>
          <div class="list-wrap-item-right-content">{{item.description| ellipsis(isMobile ? 30 : 80)}}</div>
          <div class="list-wrap-item-right-more hidden-xs-only">
            <span>[+]</span>
            <span>MORE</span>
          </div>
        </div>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile: (window.innerWidth || document.documentElement.clientWidth) < 768 
    }
  },
  props: {
    list: {
      type: Object,
      default() {
        return {
          data:[]
        }
      }
    },
    link: {
      type: String,
      default: ''
    },
    pl: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/register.scss';
@import '../../assets/css/base.scss';
  .list {
    width: 100%;
    padding-left: 260px;
    min-height: 400px;
    &-title {
      line-height: 46px;
      background-color: #eee;
      border-top: 3px solid $basecolor;
      color: $basecolor;
      span {
        font-weight: 700;
      }
    }
    &-wrap {
      &-item {
        padding: 10px;
        border-bottom: 1px solid #cfcfcf;
        overflow: hidden;
        cursor: pointer;
        height: auto;
        &:hover &-right-title{
          color: $basecolor;
        }
        &-img {
          float: left;
          display: inline-block;
          border: 2px solid $basecolor;
          font-size: 0;
        }
        &-right {
          // float: left;
          // display: inline-block;
          width: 100%;
          padding-left: 220px;
          
          &-title {
            font-size: 18px;
            font-weight: 700;
            color: #000;
            padding: 10px 0;
          }
          &-content {
            line-height: 1.4;
            font-size: 14px;
          }
          &-more {
            padding: 10px 0;
            color: $basecolor;
          }
        }
        &-right.notImage {
          padding-left: 0;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    .list {
      padding-left: 0;
      &-wrap {
        &-item {
          &-img {
            // float: none;
            border: none;
            > div {
              width: 120px !important;
              height: 80px !important;
            }
          }
          &-right {
            padding-left: 125px;
            &-title {
              font-size: 16px;
              padding: 5px 0;
            }
            &-content {}
            &-more {

            }
          }
        }
      }
    }
  }
</style>